var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 23,
    viewBox: "0 0 49 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 4975",
    width: 49,
    height: 23,
    rx: 11.5,
    style: {
      fill: "#3d6ae6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9541"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(18.75 17)",
    style: {
      fontSize: 13,
      fontFamily: "NotoSansCJKkr-Medium,Noto Sans CJK KR",
      fontWeight: 500,
      letterSpacing: "-.05em",
      fill: "#fff"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCD94\uCC9C"))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uB2E4\\uAC01\\uD615 8",
    d: "M5.53 1.306a.5.5 0 0 1 .941 0l.914 2.537a.5.5 0 0 0 .458.33l2.722.068a.5.5 0 0 1 .288.9L8.706 6.755a.5.5 0 0 0-.178.544L9.3 9.854a.5.5 0 0 1-.758.559L6.28 8.885a.5.5 0 0 0-.56 0l-2.262 1.528a.5.5 0 0 1-.758-.559L3.472 7.3a.5.5 0 0 0-.178-.544L1.148 5.141a.5.5 0 0 1 .288-.9l2.722-.068a.5.5 0 0 0 .458-.33z",
    transform: "translate(6.25 5.9)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRecommend);
export default __webpack_public_path__ + "static/media/ico_recommend.177cde66536bf41de6ac961ad31da3ff.svg";
export { ForwardRef as ReactComponent };